import React, { useEffect, useState } from "react";
import LeftNav from "../common/leftnav";
import UserList from "./user_list/userList";
import { useUser } from "../../context/UserContext";
import authService from "../../services/authService";
import UserListSkeleton from "./skeleton/UserListSkeleton";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UserManagement = () => {
  const { token } = useUser();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      if (!token) {
        console.error("No authentication token available");
        return;
      }
      try {
        const data = await authService.fetchUsers(token);
        setUsers(data);
      } catch (err) {
        setError("Failed to fetch users");
        console.error(err);

        // Show error notification with the backend error message
        const errorMessage = err.response?.data?.message || "Failed to fetch users";
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 5000,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [token]);

  return (
    <div className="d-flex">
      <LeftNav />
      <div className="dashboard-content flex-grow-1 p-4 bg-light">
        <div className="mb-4">
          <h2 className="fs-five-title fw-bold ms-2">User Management</h2>
          <p className="text-muted ms-2">As a Super Admin you can activate different accounts.</p>
          
          {/* Show Skeleton Loader while loading or if no users are found */}
          {loading || users.length === 0 ? (
            <UserListSkeleton />
          ) : (
            <UserList users={users} setUsers={setUsers} />
          )}
        </div>
      </div>
    </div>
  );
};

export default UserManagement;